import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import api from '../api'
import Y from '../../y18n'

const GET_SIMCARDS = createAction('simcards/GET_SIMCARDS')
const GET_SIMCARDS_SUCCESS = createAction('simcards/GET_SIMCARDS_SUCCESS')

const CREATE_SIMCARD = createAction('simcards/CREATE_SIMCARD')
const CREATE_SIMCARD_SUCCESS = createAction('simcards/CREATE_SIMCARD_SUCCESS')

const EDIT_SIMCARD = createAction('simcards/EDIT_SIMCARD')
const EDIT_SIMCARD_SUCCESS = createAction('simcards/EDIT_SIMCARD_SUCCESS')

const DELETE_SIMCARDS = createAction('simcards/DELETE_SIMCARDS')
const DELETE_SIMCARDS_SUCCESS = createAction('simcards/DELETE_SIMCARDS_SUCCESS')

const CLEAR_SIMCARDS = createAction('simcards/CLEAR_SIMCARDS')

const SET_ERROR = createAction('simcards/SET_ERROR')

const SELECT_ITEM = createAction('simcards/SELECT_ITEM')
const UNSELECT_ITEM = createAction('simcards/UNSELECT_ITEM')
const UNSELECT_ALL = createAction('simcards/UNSELECT_ALL')
const TOGGLE_ALL = createAction('simcards/TOGGLE_ALL')

const SET_PAGE = createAction('simcards/SET_PAGE')
const SET_ROWS_PER_PAGE = createAction('simcards/SET_ROWS_PER_PAGE')

const SET_ACTIVE = createAction('simcards/SET_ACTIVE')
const RESET_ACTIVE = createAction('simcards/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('simcards/UPDATE_ACTIVE')

const SET_NEW = createAction('simcards/SET_NEW')
const RESET_NEW = createAction('simcards/RESET_NEW')

const SET_SORT = createAction('simcards/SET_SORT')
const SET_FILTER = createAction('simcards/SET_FILTER')

const initialState = {
  items: [],
  selectedItems: [],
  allSelected: false,
  itemCount: 0,
  new: false,
  loading: false,
  sort: { orderBy: 'imsi', direction: 'asc' },
  filter: { country: '', productType: '', status: 'All' },
  rowsPerPage: 25,
  page: 0
}

export default handleActions(
  {
    [GET_SIMCARDS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_SIMCARDS_SUCCESS]: (state, action) => {
      action.payload.simcards.forEach(function (e) {
        e.checked = false
      })
      var items = !state.items.length || action.payload.search
        ? action.payload.simcards
        : state.items.concat(action.payload.simcards)
      return {
        ...state,
        loading: false,
        items: items,
        itemCount: action.payload.totalCount
      }
    },
    [CREATE_SIMCARD]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CREATE_SIMCARD_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [EDIT_SIMCARD]: (state, action) => ({
      ...state,
      loading: true
    }),
    [EDIT_SIMCARD_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_SIMCARDS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_SIMCARDS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [CLEAR_SIMCARDS]: (state, action) => ({
      ...state,
      items: []
    }),
    [SELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = true
      state.selectedItems.push({ ...selectedItem })
      var all = state.items && state.selectedItems ? state.items.length === state.selectedItems.length : false

      return {
        ...state,
        items: state.items,
        selectedItems: state.selectedItems,
        allSelected: all
      }
    },
    [UNSELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = false
      var selectedItems = state.selectedItems.filter(function (element) {
        return element.id !== selectedItem.id
      })
      return {
        ...state,
        items: state.items,
        selectedItems: selectedItems,
        allSelected: false
      }
    },
    [UNSELECT_ALL]: (state, action) => ({
      ...state,
      selectedItems: [],
      allSelected: false
    }),
    [TOGGLE_ALL]: (state, action) => {
      var checked = !action.payload
      state.items.forEach(function (item) {
        item.checked = checked
      })
      return {
        ...state,
        items: state.items,
        selectedItems: checked ? [...state.items] : [],
        allSelected: checked
      }
    },
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload }
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [SET_NEW]: (state, action) => ({
      ...state,
      active: action.payload,
      new: true
    }),
    [RESET_NEW]: (state, action) => ({
      ...state,
      active: null,
      new: false
    }),
    [SET_PAGE]: (state, action) => ({
      ...state,
      page: action.payload
    }),
    [SET_ROWS_PER_PAGE]: (state, action) => ({
      ...state,
      rowsPerPage: action.payload
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: { orderBy: action.payload, direction: state.sort.direction === 'asc' ? 'desc' : 'asc' }
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return { ...state, filter: filter }
    }
  },
  initialState
)

export const getSimcards = (searchText = null) => {
  return (dispatch, getState) => {
    const page = getState().simcards.page
    const rowsPerPage = getState().simcards.rowsPerPage
    const items = getState().simcards.items
    if (searchText === null && items.length !== 0 && page * rowsPerPage < items.length) return null
    if (searchText !== null) {
      dispatch(CLEAR_SIMCARDS())
    }
    dispatch(GET_SIMCARDS())
    return api
      .get('simcards/getSimcards', '', `page=${page}&count=${rowsPerPage}&searchText=${searchText || ''}`)
      .then(result => {
        dispatch(GET_SIMCARDS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Error: ${error}`))
      })
  }
}

export const createSimcard = simcard => {
  return dispatch => {
    dispatch(CREATE_SIMCARD())
    return api
      .post('simcards/createSimcard', '', simcard)
      .then(result => {
        dispatch(CREATE_SIMCARD_SUCCESS(result))
        dispatch(clearSimcards())
        dispatch(getSimcards())
        dispatch(resetNew())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Error: ${error}`))
      })
  }
}

export const editSimcard = simcard => {
  return dispatch => {
    dispatch(EDIT_SIMCARD())
    return api
      .post('simcards/updateSimcard', simcard.id, { productId: simcard.productId, country: simcard.country })
      .then(result => {
        dispatch(EDIT_SIMCARD_SUCCESS(result))
        dispatch(clearSimcards())
        dispatch(getSimcards())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Error: ${error}`))
      })
  }
}

export const deleteItems = () => {
  return (dispatch, getState) => {
    const simcardIds = getState().simcards.selectedItems.map(s => s.id)
    dispatch(DELETE_SIMCARDS())
    return api
      .post('simcards/deleteSimcards', null, { simcardIds: simcardIds })
      .then(result => {
        dispatch(DELETE_SIMCARDS_SUCCESS(result))
        dispatch(clearSimcards())
        dispatch(getSimcards())
        dispatch(unselectAll())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const changeStatus = (id, name, status) => {
  return (dispatch, getState) => {
    dispatch(updateActive(name, status))
    return api
      .post('simcards/UpdateSimcardStatus', id, { name: name, status: status })
      .then(result => {
        dispatch(clearSimcards())
        dispatch(getSimcards())
      })
      .catch(error => {
        dispatch(globalMessageActions.setGlobalError(Y`Could not update status for simcard. Error: ${error}`))
      })
  }
}

export const search = searchText => {
  return dispatch => {
    dispatch(getSimcards(searchText))
  }
}

export const setActive = simcard => {
  return dispatch => {
    dispatch(SET_ACTIVE(simcard))
  }
}

export const resetActive = () => {
  return dispatch => {
    dispatch(RESET_ACTIVE())
  }
}

export const setNew = reset => {
  return dispatch => {
    const newSimcards = {
      imsi: '23820870',
      numberOfSimcards: '',
      productId: '',
      country: ''
    }
    dispatch(SET_NEW(newSimcards))
  }
}

export const resetNew = () => {
  return dispatch => {
    dispatch(RESET_NEW())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const selectItem = item => {
  return dispatch => {
    dispatch(SELECT_ITEM(item))
  }
}

export const unselectItem = item => {
  return dispatch => {
    dispatch(UNSELECT_ITEM(item))
  }
}

export const unselectAll = () => {
  return dispatch => {
    dispatch(UNSELECT_ALL())
  }
}

export const toggleAll = checked => {
  return dispatch => {
    dispatch(TOGGLE_ALL(checked))
  }
}

export const setSort = value => {
  return dispatch => {
    dispatch(SET_SORT(value))
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}

export const setPage = value => {
  return dispatch => {
    dispatch(SET_PAGE(value))
  }
}

export const setRowsPerPage = value => {
  return dispatch => {
    dispatch(SET_ROWS_PER_PAGE(value))
  }
}

export const clearSimcards = () => {
  return dispatch => {
    dispatch(CLEAR_SIMCARDS())
  }
}



// WEBPACK FOOTER //
// ./src/store/simcards/index.js